/* eslint-disable camelcase */
import { trackPage, trackClick } from ".";
import PagesEnum from "./enums/pages";
import ChaptersEnum from "./enums/chapters";
import LevelsEnum from "./enums/levels";
import ClickTypes from "./enums/click-types";
import ClicksEnum from "./enums/clicks";

// Pages tracking

export function trackConsentPage() {
  return trackPage({
    page: PagesEnum.Authorize,
    page_chapter1: ChaptersEnum.Authorize,
    site_level2: LevelsEnum.Login,
  });
}

// Clicks tracking

export function trackClickConsent(consent: boolean) {
  return trackClick({
    click: consent ? ClicksEnum.AcceptConsentSSO : ClicksEnum.DeniedConsentSSO,
    click_type: ClickTypes.Action,
    click_chapter1: ChaptersEnum.Authorize,
    site_level2: LevelsEnum.Login,
  });
}
